import React from 'react'
import TaskItemButton from '../TaskItemButton/TaskItemButton'
import TaskItemSegmentImage from '../TaskItemSegmentImage/TaskItemSegmentImage'
import TaskItemExtraButton from '../TaskItemExtraButton/TaskItemExtraButton'
import TaskItemShowPrizeClothesButton from '../TaskItemShowPrizeClothesButton/TaskItemShowPrizeClothesButton'
import { useVisibleFooter } from '../../../../hooks/shared/quests/useVisibleFooter'
import TaskItemPromocodeButton from '../TaskItemPromocodeButton/TaskItemPromocodeButton'
import TaskItemButtonLink2 from '../TaskItemButtonLink2/TaskItemButtonLink2'

export default function TaskItemFooter({ quest, taskCallback }) {
  const isVisibleFooter = useVisibleFooter({ quest })

  return (
    isVisibleFooter && (
      <div className={'task__item-footer'}>
        <TaskItemSegmentImage quest={quest} />
        <TaskItemButton
          quest={quest}
          taskCallback={taskCallback}
        />
        <TaskItemExtraButton quest={quest} />
        <TaskItemShowPrizeClothesButton quest={quest} />
        <TaskItemPromocodeButton quest={quest} />
        <TaskItemButtonLink2 quest={quest} />
      </div>
    )
  )
}
